import React from 'react'
import ProgressiveImage from 'react-progressive-image'

import GoldBgr from 'assets/images/backgrounds/bgr-gold.webp'
import GoldBgr64 from 'assets/images/backgrounds/bgr-gold-placeholder'

import Link, { Theme as ThemeLink } from 'components/base/Link'
import ButtonRow from 'components/base/Button/Row'

import ContactInfoDetails from './Details'

import {
  ContactInfoWrap,
  SubpageSection,
} from './styles'

const ContactInfo: React.FC = (): React.ReactElement => (
  <ProgressiveImage
    src={GoldBgr}
    placeholder={GoldBgr64}
  >
    {(src: string, loading: boolean): React.ReactElement => (
      <ContactInfoWrap img={src} isLoading={loading}>
        <SubpageSection>
          <ContactInfoDetails />
          <ButtonRow>
            <Link theme={ThemeLink.button} to='/contact/'>
              View Contact Info
            </Link>
          </ButtonRow>
        </SubpageSection>
      </ContactInfoWrap>
    )}
  </ProgressiveImage>
)

export default ContactInfo
